@switch (linkType) {
    @case ('disabled') {
        <a [sfHtmlAttributes]="item.attributes ?? {}" [ngClass]="item | sidebarNavLink">
            <ng-container *ngTemplateOutlet="iconTemplate; context: { $implicit: item }" />
            <sq-sidebar-nav-link-content [item]="item" />
            @if (item.badge) {
                <span [ngClass]="item | sidebarNavBadge">{{ item.badge.text }}</span>
            }
        </a>
    }
    @case ('action') {
        <a
            (click)="actionClicked($event)"
            [sfHtmlAttributes]="item.attributes ?? {}"
            href="#"
            role="button"
            [ngClass]="item | sidebarNavLink">
            <ng-container *ngTemplateOutlet="iconTemplate; context: { $implicit: item }" />
            <sq-sidebar-nav-link-content [item]="item" />
            @if (item.badge) {
                <span [ngClass]="item | sidebarNavBadge">{{ item.badge.text }}</span>
            }
        </a>
    }
    @case ('external') {
        <a
            (click)="linkClicked()"
            [sfHtmlAttributes]="item.attributes ?? {}"
            target="_blank"
            [href]="href"
            [ngClass]="item | sidebarNavLink">
            <ng-container *ngTemplateOutlet="iconTemplate; context: { $implicit: item }" />
            <sq-sidebar-nav-link-content [item]="item" />
            @if (item.badge) {
                <span [ngClass]="item | sidebarNavBadge">{{ item.badge.text }}</span>
            }
        </a>
    }
    @default {
        <a
            (click)="linkClicked()"
            [sfHtmlAttributes]="item.attributes ?? {}"
            [fragment]="item.linkProps?.fragment"
            [ngClass]="item | sidebarNavLink"
            [preserveFragment]="item.linkProps?.preserveFragment ?? false"
            [queryParamsHandling]="item.linkProps?.queryParamsHandling"
            [queryParams]="item.linkProps?.queryParams ?? null"
            [replaceUrl]="item.linkProps?.replaceUrl ?? false"
            [routerLinkActiveOptions]="item.linkProps?.routerLinkActiveOptions ?? { exact: false }"
            [routerLink]="item.url"
            [skipLocationChange]="item.linkProps?.skipLocationChange ?? false"
            [state]="item.linkProps?.state ?? {}"
            [target]="item.attributes?.['target']"
            routerLinkActive="active">
            <!--    [class.active]="linkActive"-->
            <ng-container *ngTemplateOutlet="iconTemplate; context: { $implicit: item }" />
            <sq-sidebar-nav-link-content [item]="item" />
            @if (item.badge) {
                <span [ngClass]="item | sidebarNavBadge">{{ item.badge.text }}</span>
            }
        </a>
    }
}
<ng-template #iconTemplate let-item>
    <!--  <i *ngIf="item?.icon" [ngClass]="item | cSidebarNavIcon"></i>-->
    @if (item?.icon && !item?.faIcon) {
        <span class="nav-icon">
            <span [ngClass]="item.icon ?? ''"></span>
        </span>
    }

    @if (!!item.faIcon) {
        <div class="nav-icon">
            <fa-icon [icon]="item.faIcon"></fa-icon>
        </div>
    }
</ng-template>
